import { gql } from '@apollo/client';

export default gql`
  mutation createRequest(
    $branch: String
    $title: String
    $desc: String
    $time: Date
    $locationLink: String
    $address: String
    $attachments: String
    $customerId: String
    $customerName: String
    $customerNameAr: String
    $customerPhone: String
    $departmentId: String
    $departmentName: String
    $departmentNameAr: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $contractId: String
    $contractName: String
    $contractNameAr: String
    $resourseId: String
    $resourseName: String
    $resourseNameAr: String
    $paymentType: String
  ) {
    createRequest(
      branch: $branch
      title: $title
      desc: $desc
      time: $time
      locationLink: $locationLink
      address: $address
      attachments: $attachments
      customerId: $customerId
      customerName: $customerName
      customerNameAr: $customerNameAr
      customerPhone: $customerPhone
      departmentId: $departmentId
      departmentName: $departmentName
      departmentNameAr: $departmentNameAr
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      contractId: $contractId
      contractName: $contractName
      contractNameAr: $contractNameAr
      resourseId: $resourseId
      resourseName: $resourseName
      resourseNameAr: $resourseNameAr
      paymentType: $paymentType
    ) {
      ok
      message
      data
      error
    }
  }
`;
